import { sendRequestSKUNotification, sendRequestSeatNotification, sendRequestTrialNotification } from 'purchase-motions-api/mutation/requestNotification';
import Raven from 'raven-js';
import { track } from '../utils/usageTracker';
export const requestProduct = ({
  apiName
}) => {
  return sendRequestSKUNotification({
    apiName
  }).then(() => {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    track('request-upgrade', {
      action: 'request sku notification succeeded',
      apiName
    });
  }).catch(e => {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    track('request-upgrade', {
      action: 'request sku notification failed',
      apiName
    });
    Raven.captureException(new Error('requestSku: Failed to submit product request notification', {
      cause: e
    }), {
      extra: {
        apiName
      }
    });
    throw e;
  });
};
export const requestTrial = ({
  apiName
}) => {
  return sendRequestTrialNotification({
    apiName
  }).then(() => {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    track('request-upgrade', {
      action: 'request trial notification succeeded',
      apiName
    });
  }).catch(e => {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    track('request-upgrade', {
      action: 'request trial notification failed',
      apiName
    });
    Raven.captureException(e);
    throw e;
  });
};
export const requestSeatUpgrade = ({
  apiName,
  requestReason,
  requestedSeatType
}) => {
  return sendRequestSeatNotification({
    apiName,
    requestReason,
    requestedSeatType
  }).then(() => {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    track('request-upgrade', {
      action: 'request seat succeeded',
      apiName: requestedSeatType ? undefined : apiName,
      requestReason,
      selectedSeatType: requestedSeatType
    });
  }).catch(e => {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    track('request-upgrade', {
      action: 'request seat failed',
      apiName: requestedSeatType ? undefined : apiName,
      requestReason,
      selectedSeatType: requestedSeatType
    });
    Raven.captureException(e);
    throw e;
  });
};